<template>
  <div class="material-card">
    <div class="material-intro">
      <img :src="thumbnail || '../assets/images/material_test.png'" :alt="name">
      <p>{{ name }}</p>
    </div>

    <div class="material-unit">
      <p>厚み（mm）</p>
      <p>単価</p>
    </div>

    <div class="material-price-item" v-for="item in materialAssortments">
      <input
        type="checkbox"
        v-model="item.is_available"
        @change="onUpdate(item.id, item.is_available, item.unit_price)"
      />
      <p>{{ item.thickness }}</p>
      <input
        type="text"
        v-model="item.unit_price"
        @change="onUpdate(item.id, item.is_available, item.unit_price)"
        :style="{ visibility: item.is_available ? 'visible' : 'hidden' }"
      />
      <span :style="{ visibility: item.is_available ? 'visible' : 'hidden' }">円</span>
    </div>
  </div>
</template>

<script>
export default  {
  name: "MaterialCard",
  props: {
    name: '',
    thumbnail: '',
    matArr: Array
  },

  data () {
    return {}
  },

  computed: {
    materialAssortments: function () {
      return this.matArr;
    }
  },

  methods: {
    onUpdate (id, is_available, unit_price) {
      this.$emit('materialUpdate', { id, is_available, unit_price });
    }
  }
}
</script>

<style lang="scss" scoped>
  .material-card {
    width: 200px;
    margin-right: 2rem;

    .material-intro {
      display: flex;
      align-items: start;
      justify-content: start;
      margin-top: 1rem;
      margin-bottom: 1rem;

      img {
        width: 70px;
        height: 70px;
        border-radius: 10px;
        margin-right: .5rem;
      }
      // p {}
    }

    .material-unit {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      background-color: #eeeeee;
      border-radius: 10px;
      width: 100%;
      padding: .5rem;

      p {
        margin: 0 1rem;
      }
    }

    .material-price-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: .5rem 0;
      border-bottom: 1px solid #eeeeee;
      input[type=checkbox] {
        margin-right: 1rem;
      }
      p {
        margin-right: 2rem;
      }
      input[type=text] {
        background-color: #eeeeee;
        padding: 5px 10px;
        width: 80px;
        text-align: right;
        border-radius: 5px;
      }

      span {
        margin-left: .5rem;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/MaterialCard.vue